import { useMutation, useQueryClient } from "@tanstack/react-query";

import { apiGqlClient } from "~/libs/gql";
import { graphql } from "~/types/__generated/gql";
import {
	UpdateFilePDFMutation,
	UpdateFilePDFMutationVariables,
} from "~/types/__generated/gql/graphql";
import { getFileByIdQueryKey } from "../useGetFileById";

const query = /* GraphQL */ `
	mutation UpdateFilePDF($id: ObjectID!, $input: UpdateFilePDFInput!) {
		updateFilePDF(id: $id, input: $input) {
			_id
		}
	}
`;

export type UpdateFilePDFVariables = UpdateFilePDFMutationVariables;
export type UpdateFilePDFResults = UpdateFilePDFMutation["updateFilePDF"];

export const useUpdateFilePDF = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (variables: UpdateFilePDFVariables) =>
			apiGqlClient
				.request(graphql(query), variables)
				.then((res) => res.updateFilePDF),
		onSuccess: ({ _id }) => {
			void queryClient.invalidateQueries(getFileByIdQueryKey(_id));
		},
	});
};
